import React, {createContext, useCallback, useContext, useMemo, useState} from 'react';

const HelpDrawerContext = createContext(null);

export function HelpDrawerProvider({children}) {
    const [isOpen, setIsOpen] = useState(false);
    const [initialTab, setInitialTab] = useState('basic');
    const [focusedStepKey, setFocusedStepKey] = useState(null);

    const openDrawer = useCallback((tab = 'basic', options = {}) => {
        setInitialTab(tab);
        setFocusedStepKey(options.stepKey || null);
        setIsOpen(true);
    }, []);

    const closeDrawer = useCallback(() => {
        setIsOpen(false);
    }, []);

    const toggleDrawer = useCallback(() => {
        setIsOpen(prev => !prev);
    }, []);

    const value = useMemo(() => ({
        isOpen,
        initialTab,
        focusedStepKey,
        openDrawer,
        closeDrawer,
        toggleDrawer,
    }), [isOpen, initialTab, focusedStepKey, openDrawer, closeDrawer, toggleDrawer]);

    return (
        <HelpDrawerContext.Provider value={value}>
            {children}
        </HelpDrawerContext.Provider>
    );
}

export function useHelpDrawer() {
    const ctx = useContext(HelpDrawerContext);
    if (!ctx) {
        return {
            isOpen: false,
            initialTab: 'basic',
            focusedStepKey: null,
            openDrawer: () => {},
            closeDrawer: () => {},
            toggleDrawer: () => {},
        };
    }
    return ctx;
}
